import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import Color from "@mapmycustomers/shared/enum/Color";
import {
  EntityTypesSupportedByMapsPage,
  EntityTypeSupportingGroups,
  Group,
} from "@mapmycustomers/shared/types/entity";

import { getGroup, getGroupEntityType } from "@app/scene/map/store/groupMode/selectors";
import { RootState } from "@app/store/rootReducer";
import colors from "@app/styles/_colors.module.scss";

import ColorBadge from "../../ColorBadge/ColorBadge";

import ColorKey from "./ColorKey";

interface Props {
  entityType: EntityTypesSupportedByMapsPage;
  group?: Group;
  groupEntityType?: EntityTypeSupportingGroups;
}

const GroupViewColorKey: React.FC<Props> = ({ entityType, group, groupEntityType }) => {
  const intl = useIntl();

  if (!group || groupEntityType !== entityType) {
    return null;
  }

  return (
    <ColorKey>
      <div>
        <ColorBadge
          color={group.color ?? Color.BLACK}
          label={intl.formatMessage({
            id: "map.layer.colorKey.legend.group.option.inside",
            defaultMessage: "Group pin",
            description: "Inside option in Group Color legend",
          })}
        />
      </div>
      <div>
        <ColorBadge
          color={colors.disabledGray}
          label={intl.formatMessage({
            id: "map.layer.colorKey.legend.group.option.outside",
            defaultMessage: "Other pin",
            description: "Outside option in Group Color legend",
          })}
        />
      </div>
    </ColorKey>
  );
};

const mapStateToProps = (state: RootState) => ({
  group: getGroup(state),
  groupEntityType: getGroupEntityType(state),
});

export default connect(mapStateToProps, {})(GroupViewColorKey);
